import {
  pluckNumber,
  pluck,
  parseTooltext,
  parseUnsafeString,
  getDashStyle,
  getDefinedColor,
  getValidValue,
  toRaphaelColor,
  getCrispValue,
  getFirstValue,
  hashify,
  convertColor, getLightColor, getColumnColor
} from '@fusioncharts/core/src/lib';

import ColumnDataset, { PATTERN_TYPES } from '@fusioncharts/charts/src/dataset/column';
import { addDep } from '@fusioncharts/core/src/dependency-manager';
import waterFall2DAnimation from './index.animation';

let HUNDREDSTRING = '100',
  PLOTBORDERCOLOR = 'plotBorderColor',
  PLOTGRADIENTCOLOR = 'plotGradientColor',
  COMMA = ',',
  BLANK = '',
  SHOWSHADOW = 'showShadow',
  NONE = 'none',
  MAX_MITER_LINEJOIN = 2,
  M = 'M',
  H = 'H',
  UNDEF;
addDep({
  name: 'waterFall2DAnimation',
  type: 'animationRule',
  extension: waterFall2DAnimation
});
class WaterFall2DDataset extends ColumnDataset {
  /**
   * Sets the type of the component
   * @return {string} type
   */
  getType () {
    return 'dataset';
  }
  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'waterFall2D';
  }
  configure (datasetJSON) {
    if (!datasetJSON) {
      return false;
    }
    this.trimData(datasetJSON);
    this.config.JSONData = datasetJSON;
    var catData,
      catObj,
      dataSet = this,
      chart = dataSet.getFromEnv('chart'),
      // logic = chart.logic,
      conf = dataSet.config,
      // fcJSON = dataSet.fcJSON,
      JSONData = dataSet.config.JSONData,
      setDataArr = JSONData.data,
      setDataLen = setDataArr && setDataArr.length, // eslint-disable-line good-practices/no-single-usage-variable
      catLen = dataSet.getFromEnv('xAxis').getTicksLen(), // eslint-disable-line good-practices/no-single-usage-variable
      len = Math.min(catLen, setDataLen),
      chartAttr = chart.getFromEnv('dataSource').chart,
      colorM = dataSet.getFromEnv('color-manager'),
      showplotborder,
      plotColor = colorM.getPlotColor(dataSet.index || dataSet.positionIndex),
      plotBorderDash = pluckNumber(JSONData.dashed, chartAttr.plotborderdashed, 0),
      chartConfig = chart.config,
      usePlotGradientColor = chartConfig.useplotgradientcolor, // eslint-disable-line good-practices/no-single-usage-variable
      showTooltip = pluckNumber(chartAttr.showtooltip, 1), // eslint-disable-line good-practices/no-single-usage-variable
      tooltipSepChar = parseUnsafeString(pluck(chartAttr.tooltipsepchar, ', ')), // eslint-disable-line good-practices/no-single-usage-variable
      formatedVal,
      parserConfig,
      setTooltext,
      // seriesname,
      macroIndices,
      // tempPlotfillAngle,
      toolText,
      plotDashLen,
      plotDashGap,
      plotBorderThickness,
      isRoundEdges,
      showHoverEffect,
      plotfillAngle,
      plotFillAlpha,
      plotFillRatio,
      plotgradientcolor,
      plotBorderAlpha,
      plotBorderColor,
      plotBorderDashStyle,
      initailPlotBorderDashStyle,
      setData,
      setValue,
      dataObj,
      config,
      // label,
      colorArr,
      hoverColor,
      hoverAlpha,
      hoverGradientColor,
      hoverRatio,
      hoverAngle,
      hoverBorderColor,
      hoverBorderAlpha,
      hoverBorderThickness,
      hoverBorderDashed,
      hoverBorderDashGap,
      hoverBorderDashLen,
      hoverDashStyle,
      hoverColorArr,
      dataStore = dataSet.components.data,
      numberFormatter = dataSet.getFromEnv('number-formatter'),
      toolTipValue,
      setDisplayValue,
      // isBar = chart.isBar,
      // is3D = chart.config.is3D,
      // isStacked = chart.isStacked,
      isBar = false,
      is3D = false,
      isStacked = false,
      stack100Percent,
      enableAnimation,
      parentYAxis,
      setDataDashed,
      setDataPlotDashLen,
      setDataPlotDashGap,
      i,
      reflowData = /* logic.chartInstance.jsVars._reflowData */ {},
      reflowDataObj = reflowData.dataObj || (reflowData.dataObj = {}),
      reflowChartObj = reflowDataObj.chart || (reflowDataObj.chart = {}),

      // fcJSON = dataSet.fcJSON,
      // isSingleSeries = chart.config.singleseries,
      lineThickness = pluck(chartAttr.connectorthickness, 1), // eslint-disable-line good-practices/no-single-usage-variable
      showSum,
      dataLabel,
      showLabel,
      itemValue,
      maxValue = -Infinity,
      minValue = Infinity,
      seriesSum = 0,
      total = 0,
      lastComTotal = 0,
      issum,
      zLine,
      setColor,
      cumulative,
      sumObj,
      countPoint,
      plotfillangle;

    conf.minAbsNonZeroValue = Infinity;
    conf.minAbsNonZeroData = {};
    dataSet.setState('visible',
      pluckNumber(JSONData.visible, !Number(JSONData.initiallyhidden), 1) === 1);
    // dataplot border width. Managing for 3D too
    showplotborder = conf.showplotborder = pluckNumber(chartAttr.showplotborder, is3D ? 0 : 1);
    // waterfall2D chart doesn't show the plotborder by default until we set showplotborder true
    conf.plotBorderThickness = plotBorderThickness = showplotborder ? (is3D ? 1 : pluckNumber(
      chartAttr.plotborderthickness, 1)) : 0;
    // whether to use round edges or not in the waterfall2D
    conf.isRoundEdges = isRoundEdges = pluckNumber(chartAttr.useroundedges, 0);
    // dataplot border alpha
    conf.plotBorderAlpha = plotBorderAlpha = showplotborder ? pluck(chartAttr.plotborderalpha,
      plotFillAlpha, HUNDREDSTRING) : 0;
    // dataplot border color
    conf.plotbordercolor = plotBorderColor = pluck(chartAttr.plotbordercolor,
      is3D ? '#ffffff' : colorM.getColor(PLOTBORDERCOLOR).split(COMMA)[0]);
    // GradientColor of the plot fill
    conf.plotgradientcolor = plotgradientcolor = usePlotGradientColor ? getDefinedColor(
      chartAttr.plotgradientcolor, colorM.getColor(PLOTGRADIENTCOLOR)) : BLANK;
    conf.plotDashLen = plotDashLen = pluckNumber(chartAttr.plotborderdashlen, 6);
    conf.showTextOutline = pluckNumber(chartAttr.textoutline, 0);
    conf.plotDashGap = plotDashGap = pluckNumber(chartAttr.plotborderdashgap, 3);
    // use3DLighting to show gredient color effect in waterfall2D charts
    conf.use3DLighting = pluckNumber(chartAttr.use3dlighting, 1);
    conf.showSum = showSum = pluckNumber(chartAttr.showsumatend, 1);
    conf.plotColor = plotColor = pluck(JSONData.color, plotColor);
    // defaultAngle depend upon item value
    conf.plotfillAngle = plotfillAngle = pluckNumber(360 - chartAttr.plotfillangle, 90);
    conf.showShadow = (isRoundEdges || is3D) ? pluckNumber(chartAttr.showshadow, 1)
      : pluckNumber(chartAttr.showshadow, colorM.getColor(SHOWSHADOW));
    conf.usePattern = pluckNumber(chartConfig.usePattern, 0);
    conf.patternType = PATTERN_TYPES.includes(JSONData.patterntype)
      ? JSONData.patterntype
      : chartConfig.patternType;
    conf.patternDensity = pluckNumber(JSONData.patterndensity, chartConfig.patternDensity);
    conf.patternAlpha = pluckNumber(JSONData.patternalpha, chartConfig.patternAlpha);
    conf.patternBgColor = pluck(JSONData.patternbgcolor, conf.patternBgColor);
    conf.showHoverEffect = showHoverEffect = pluckNumber(chartAttr.plothovereffect,
      chartAttr.showhovereffect, UNDEF);

    conf.usePattern && (conf.showHoverEffect = showHoverEffect = 0);

    // todo start - **Needs to remove them if not required in waterfall2D*****************
    conf.plotFillAlpha = plotFillAlpha = pluck(JSONData.alpha, chartAttr.plotfillalpha, HUNDREDSTRING);
    conf.plotRadius = pluckNumber(chartAttr.useRoundEdges, conf.isRoundEdges ? 1 : 0);
    conf.plotFillRatio = plotFillRatio = pluck(JSONData.ratio, chartAttr.plotfillratio);
    conf.dashed = plotBorderDash;
    conf.plotBorderDashStyle = initailPlotBorderDashStyle = plotBorderDash // eslint-disable-line good-practices/no-single-usage-variable
      ? getDashStyle(plotDashLen, plotDashGap) : 'none';
    conf.showValues = pluckNumber(JSONData.showvalues, chartAttr.showvalues, 1);
    conf.valuePadding = pluckNumber(chartAttr.valuepadding, 2);
    conf.enableAnimation = enableAnimation = pluckNumber(chartAttr.animation,
      chartAttr.defaultanimation, 1);
    conf.animation = !enableAnimation ? false : {
      duration: pluckNumber(chartAttr.animationduration, 1) * 1000
    };
    reflowChartObj.transposeAnimation = conf.transposeAnimation =
                pluckNumber(chartAttr.transposeanimation, reflowChartObj.transposeAnimation, enableAnimation);
    conf.transposeAnimDuration = pluckNumber(chartAttr.transposeanimduration, 0.2) * 1000;

    conf.showTooltip = pluckNumber(chartAttr.showtooltip, 1);
    conf.stack100Percent = stack100Percent =
                pluckNumber(chart.stack100percent, chartAttr.stack100percent, 0);
    conf.definedGroupPadding = Math.max(pluckNumber(chartAttr.plotspacepercent), 0);
    conf.plotSpacePercent = Math.max(pluckNumber(chartAttr.plotspacepercent, 20) % 100, 0);
    conf.maxColWidth = pluckNumber(isBar ? chartAttr.maxbarheight : chartAttr.maxcolwidth, 50);
    conf.showPercentValues = pluckNumber(chartAttr.showpercentvalues, (isStacked && stack100Percent)
      ? 1 : 0);
    conf.showPercentInToolTip = pluckNumber(chartAttr.showpercentintooltip,
      (isStacked && stack100Percent) ? 1 : 0);
    conf.plotPaddingPercent = pluckNumber(chartAttr.plotpaddingpercent);
    conf.rotateValues = pluckNumber(chartAttr.rotatevalues) ? 270 : 0;
    conf.placeValuesInside = pluckNumber(chartAttr.placevaluesinside, 0);
    /* conf.zeroPlaneColor = chart.options.chart.zeroPlaneColor;
    conf.zeroPlaneBorderColor = chart.options.chart.zeroPlaneBorderColor;
    conf.zeroPlaneShowBorder = chart.options.chart.zeroPlaneShowBorder; */
    conf.parentYAxis = parentYAxis = pluck(JSONData.parentyaxis && JSONData.parentyaxis.toLowerCase(), // eslint-disable-line good-practices/no-single-usage-variable
      'p') === 's' ? 1 : 0;
    // todo end ***************
    conf.defaultPadding = {
      left: 0.5,
      right: 0.5
    };

    dataSet.setState('dirty', true);

    if (!dataStore) {
      dataStore = dataSet.components.data = [];
    }
    // storing the configurations for z-line.
    conf.zLine = zLine = {
      step: true,
      data: [],
      dashStyle: chartAttr.connectordashed === '1' ? getDashStyle(
        pluckNumber(chartAttr.connectordashlen, 2), pluckNumber(
          chartAttr.connectordashgap, 2)) : NONE,
      useForwardSteps: true,
      color: convertColor(pluck(chartAttr.connectorcolor, '000000'), pluck(chartAttr.connectoralpha,
        100)),
      lineWidth: lineThickness
    };
    // calculate sum
    for (i = 0; i < len; i += 1) {
      // individual set level data
      setData = setDataArr[i];
      itemValue = numberFormatter.getCleanValue(setData.value);
      issum = pluckNumber(setData.issum, 0);
      // If its vline then don't calculate
      if (setData.vline || issum) {
        delete setData._value;
        continue;
      }
      seriesSum += itemValue;
      setData._value = itemValue;
    }
    // Is we have to show sum at end then create a dummy set for total
    if (showSum) {
      // converts the truty value of showSum to Boolean TRUE flag.
      showSum = true;
      len += 1;
      sumObj = {
        label: getFirstValue(chartAttr.sumlabel, 'Total'),
        // todo remove _value if not required.
        _value: seriesSum,
        value: seriesSum,
        issum: 1,
        cumulative: 1
      };
    }
    // Iterate through all level data
    // Managing the data value labels and other cosmetics inside this loop
    for (i = 0, countPoint = 0; i < len; i += 1) {
      // individual data obj
      setData = setDataArr[i];
      dataObj = dataStore[i];
      config = dataObj && dataObj.config;

      if (!dataObj) {
        dataObj = dataStore[i] = {
          graphics: {}
        };
      }

      if (!dataObj.config) {
        config = dataStore[i].config = {};
      }
      if (!setData && showSum) {
        setData = setDataArr[i] = sumObj;
      }
      plotColor = pluck(setData.color, colorM.getPlotColor(i));
      // Managing vLines in between <set> elements
      // If its vline
      // we call the grid manager addVline function, that creates vline
      // and we stop execution here and continue the loop to next data
      if (dataObj.vline) {
        // todo need to validate with axis module and add vline.
        continue;
      }
      // get the valid value
      // parsePointValue check the its a value value of not and return
      // the valid value
      itemValue = setData._value;
      delete setData._value;
      config.issum = (issum = pluckNumber(setData.issum, 0));
      cumulative = (config.isCumulative = pluckNumber(setData.cumulative, 1));
      if (issum) {
        itemValue = cumulative ? total : (total === lastComTotal ? total : (total - lastComTotal));
        config.lastComTotal = lastComTotal;
        lastComTotal = total;
        zLine.data.push({
          y: null,
          x: countPoint - 0.5
        });
      } else {
        total += itemValue;
      }

      config.valuePadding = pluckNumber(setData.valuepadding, conf.valuePadding);

      maxValue = Math.max(maxValue, total);
      minValue = Math.min(minValue, total);
      if (itemValue !== 0 && conf.minAbsNonZeroValue > Math.abs(itemValue)) {
        conf.minAbsNonZeroValue = Math.abs(itemValue);
        conf.minAbsNonZeroData = config;
      }
      // store the cumulative total
      config.total = total;
      // we check showLabel in individual data
      // if its set to 0 than we do not show the particular label
      showLabel = config.showLabel = pluckNumber(setData.showlabel, chartAttr.showlabels, 1);
      // Label of the data
      // getFirstValue returns the first defined value in arguments
      // we check if showLabel is not set to 0 in data
      // then we take the label given in data, it can be given using label as well as name too
      // we give priority to label if label is not there, we check the name attribute
      dataLabel = config.dataLabel = parseUnsafeString(!showLabel ? BLANK : getFirstValue(setData.label,
        setData.name));

      // <set> cosmetics
      // Color of the particular data
      if (itemValue > 0) {
        setColor = pluck(setData.color, chartAttr.positivecolor, plotColor);
        if (showHoverEffect !== 0) {
          hoverColor = pluck(setData.positivehovercolor, chartAttr.positivehovercolor,
            chartAttr.plotfillhovercolor, chartAttr.columnhovercolor, setColor);
        }
      } else {
        setColor = pluck(setData.color, chartAttr.negativecolor, plotColor);
        if (showHoverEffect !== 0) {
          hoverColor = pluck(setData.negativehovercolor, chartAttr.negativehovercolor,
            chartAttr.plotfillhovercolor, chartAttr.columnhovercolor, setColor);
        }
      }
      // Setting the angle for plot fill for negative data
      if (itemValue < 0) {
        plotfillangle = 360 - plotfillAngle;
      } else {
        plotfillangle = plotfillAngle;
      }
      plotFillAlpha = pluck(setData.alpha, conf.plotFillAlpha);
      config.dashed = setDataDashed = pluckNumber(setData.dashed, conf.dashed);
      setDataPlotDashLen = pluckNumber(setData.dashlen, plotDashLen);
      setDataPlotDashGap = plotDashGap = pluckNumber(setData.dashgap, plotDashGap);

      config.plotFillAlpha = plotFillAlpha;
      config.plotBorderAlpha = plotBorderAlpha;
      config.showValue = pluckNumber(setData.showvalue, conf.showValues);
      // todo clean the variables
      config.setValue = setValue = itemValue;
      config.setLink = pluck(setData.link);
      config.toolTipValue = toolTipValue = numberFormatter.dataLabels(setValue, parentYAxis);
      config.setDisplayValue = setDisplayValue = getValidValue(parseUnsafeString(setData.displayvalue));
      config.displayValue = pluck(setDisplayValue, toolTipValue);

      config.plotBorderDashStyle = plotBorderDashStyle = setDataDashed === 1
        ? getDashStyle(setDataPlotDashLen, setDataPlotDashGap)
        : (setDataDashed === 0 ? 'none' : initailPlotBorderDashStyle);

      config.shadow = {
        opacity: conf.showShadow ? plotFillAlpha / 100 : 0
      };

      config.dataLabelStyle = dataSet._configureDataLabelStyle(setData);

      config.patternType = PATTERN_TYPES.includes(setData.patterntype)
        ? setData.patterntype
        : conf.patternType;
      config.patternAngle = pluckNumber(setData.patternangle, JSONData.patternangle,
        chartAttr.patternangle, config.patternType === PATTERN_TYPES[0] ? 40 : 0);
      config.patternDensity = pluckNumber(setData.patterndensity, conf.patternDensity);
      config.patternSize = pluckNumber(setData.patternsize, JSONData.patternsize,
        config.patternType === PATTERN_TYPES[0] ? 2 : 4);
      config.patternAlpha = pluckNumber(setData.patternalpha, conf.patternAlpha);
      config.patternBgColor = pluck(setData.patternbgcolor, conf.patternBgColor);

      // Setting the color Array to be applied to the bar/column.
      config.colorArr = colorArr = getColumnColor(
        setColor + COMMA + plotgradientcolor.replace(/,+?$/, ''), plotFillAlpha, plotFillRatio,
        plotfillangle, isRoundEdges, plotBorderColor,
        // todo remove the toString() by plucking string only.
        plotBorderAlpha.toString(),
        // todo remove this dirty checks and set the flag value as required.
        (isBar ? 1 : 0), (!!is3D));

      // Parsing the hover effects only if showhovereffect is not 0.
      if (showHoverEffect !== 0) {
        // Alpha of the data
        hoverAlpha = pluck(setData.alpha, setData.hoveralpha, JSONData.hoveralpha,
          chartAttr.plotfillhoveralpha, chartAttr.columnhoveralpha, plotFillAlpha);
        hoverGradientColor = pluck(setData.hovergradientcolor,
          JSONData.hovergradientcolor, chartAttr.plothovergradientcolor, plotgradientcolor);
        !hoverGradientColor && (hoverGradientColor = '');
        // Fill ratio of the data
        hoverRatio = pluck(setData.hoverratio, JSONData.hoverratio, setData.ratio,
          chartAttr.plothoverratio, plotFillRatio);
        hoverAngle = pluckNumber(360 - setData.hoverangle,
          360 - JSONData.hoverangle, 360 - chartAttr.plothoverangle, plotfillangle);
        hoverBorderColor = pluck(setData.borderhovercolor,
          JSONData.borderhovercolor, chartAttr.plotborderhovercolor, plotBorderColor);
        hoverBorderAlpha = pluck(setData.borderhoveralpha,
          JSONData.borderhoveralpha, chartAttr.plotborderhoveralpha, plotBorderAlpha, plotFillAlpha);
        hoverBorderThickness = pluckNumber(setData.borderhoverthickness,
          JSONData.borderhoverthickness, chartAttr.plotborderhoverthickness, plotBorderThickness);
        hoverBorderDashed = pluckNumber(setData.borderhoverdashed,
          JSONData.borderhoverdashed, chartAttr.plotborderhoverdashed);
        hoverBorderDashGap = pluckNumber(setData.borderhoverdashgap,
          JSONData.borderhoverdashgap, chartAttr.plotborderhoverdashgap, plotDashLen);
        hoverBorderDashLen = pluckNumber(setData.borderhoverdashlen,
          JSONData.borderhoverdashlen, chartAttr.plotborderhoverdashlen, plotDashGap);
        hoverDashStyle = hoverBorderDashed
          ? getDashStyle(hoverBorderDashLen, hoverBorderDashGap)
          : plotBorderDashStyle;

        /* If no hover effects are explicitly defined and
                     * showHoverEffect is not 0 then hoverColor is set.
                     */
        if (showHoverEffect === 1 && hoverColor === plotColor) {
          hoverColor = getLightColor(hoverColor, 70);
        }
        config.hoverColor = hoverColor;
        config.hoverAlpha = hoverAlpha;
        config.hoverBorderColor = hoverBorderColor;
        config.hoverBorderAlpha = hoverBorderAlpha;
        // setting the hover color array which is always applied except when showHoverEffect is not 0.
        hoverColorArr = getColumnColor(
          hoverColor + ',' + hoverGradientColor,
          hoverAlpha,
          hoverRatio,
          hoverAngle,
          isRoundEdges,
          hoverBorderColor,
          hoverBorderAlpha.toString(),
          (isBar ? 1 : 0),
          (!!is3D)
        );

        config.setRolloutAttr = {
          fill: !is3D ? toRaphaelColor(colorArr[0])
            : [toRaphaelColor(colorArr[0]), !conf.use3DLighting],
          stroke: showplotborder && toRaphaelColor(colorArr[1]),
          'stroke-width': plotBorderThickness,
          'stroke-dasharray': plotBorderDashStyle
        };
        config.setRolloverAttr = {
          fill: !is3D ? toRaphaelColor(hoverColorArr[0])
            : [toRaphaelColor(hoverColorArr[0]), !conf.use3DLighting],
          stroke: showplotborder && toRaphaelColor(hoverColorArr[1]),
          'stroke-width': hoverBorderThickness,
          'stroke-dasharray': hoverDashStyle
        };
      }
      /*
                todo: Was in the old architechture and need to be validated and included in the new architechture.
                // Used to set alpha of the shadow
                    pointShadow = {
                        opacity: setAlpha / 100,
                        inverted: isBar
                    };
                // get per-point dash-style
                    pointDashStyle = setBorderDashed ?
                        getDashStyle(setBorderDashLen, setBorderDashGap, setBorderWidth) :
                        DASH_DEF;
                */
      // todo removing this category tooltext. Needs a validation.
      // label = getValidValue(parseUnsafeString(pluck (categories[i].tooltext, categories[i].label)));

      formatedVal = config.toolTipValue;

      // Parsing tooltext against various configurations provided by the user.
      config.origToolText = setTooltext = getValidValue(parseUnsafeString(pluck(setData.tooltext, JSONData.plottooltext,
        chartAttr.plottooltext), false));
      // create the tooltext
      if (!showTooltip) {
        toolText = false;
      } else if (setTooltext !== UNDEF) {
        macroIndices = [1, 2, 3, 5, 6, 7, 20, 21, 24, 25];
        parserConfig = {
          formattedValue: formatedVal,
          label: dataLabel,
          yaxisName: parseUnsafeString(chartAttr.yaxisname),
          xaxisName: parseUnsafeString(chartAttr.xaxisname),
          cumulativeValue: total,
          cumulativeDataValue: numberFormatter.dataLabels(total),
          sum: numberFormatter.dataLabels(seriesSum),
          unformattedSum: seriesSum
        };
        toolText = parseTooltext(setTooltext, macroIndices, parserConfig, setData, chartAttr, JSONData);
      } else { // determine the dispalay value then
        toolText = formatedVal === null ? false
          : (dataLabel !== BLANK) ? dataLabel + tooltipSepChar : '';
      }
      // create the displayvalue
      // if (!config.showValue) {
      //   displayValue = BLANK;
      // } else if (setDisplayValue !== UNDEF) {
      //   displayValue = setDisplayValue;
      // } else { // determine the dispalay value then
      //   displayValue = formatedVal;
      // }
      zLine.data.push({
        y: (itemValue === null) ? null : total,
        x: countPoint
      });
      countPoint += 1;

      config.originalPlotColor = hashify(plotColor);

      config.toolText = toolText;
      config.setTooltext = toolText;

      config._x = i;
      config._y = setValue;

      // if (!config.issum) {
      //   config._y = dataStore[i - 1] && dataStore[i - 1].config.total;
      // } else if (!config.isCumulative) {
      //   config._y = config.lastComTotal;
      // }
    }
    conf.maxValue = maxValue;
    conf.minValue = minValue;
    conf.connectNullData = pluckNumber(chartAttr.connectnulldata, 0);
    conf.showConnectors = pluckNumber(chartAttr.showconnectors, 1);
    // reconfiguring the category object for the axis module
    catData = JSONData.catData;
    for (i = 0; i < catData.length; i += 1) {
      catObj = catData[i];
      setDataArr.splice(catObj.index, 0, catObj.data);
    }
    dataSet.getFromEnv('xAxis').setTickValues(setDataArr);
    // No real time max min calculations are required during resize.
    dataSet.config.maxminFlag = false;
  }

  // Create pixel coordinates for the plots
  createCoordinates () {
    var dataSet = this,
      isBar = dataSet.getFromEnv('chart').isBar,
      yAxis = dataSet.getFromEnv('yAxis'),
      xAxis = dataSet.getFromEnv('xAxis'),
      yBase = yAxis.getAxisBase(), // eslint-disable-line good-practices/no-single-usage-variable
      yBasePos = yAxis.getPixel(yBase), // eslint-disable-line good-practices/no-single-usage-variable
      dataObj,
      config,
      previousY,
      i,
      Px,
      Py,
      Pb,
      yVal,
      chartConfig = dataSet.getFromEnv('chartConfig'),
      xDepth = chartConfig.xDepth || 0,
      yDepth = chartConfig.yDepth || 0,
      len = dataSet.components.data.length, // eslint-disable-line good-practices/no-single-usage-variable
      groupManager = dataSet.groupManager,
      stackConf = groupManager && groupManager.stackConf,
      dataStore = dataSet.components.data;

    !isBar && (xDepth = -xDepth);
    isBar && (yDepth = -yDepth);

    for (i = 0; i < len; i++) {
      dataObj = dataStore[i];
      config = dataObj && dataObj.config;

      if (dataObj === UNDEF) {
        continue;
      }
      yVal = config._y;
      if (!config.issum) {
        previousY = dataStore[i - 1] && dataStore[i - 1].config.total;
        previousY && (yVal += previousY);
      } else if (!config.isCumulative) {
        previousY = config.lastComTotal;
        yVal += config.lastComTotal;
      } else {
        previousY = null;
      }

      Px = xAxis.getPixel((stackConf && stackConf[i].x) || config._x) + xDepth;
      Py = yAxis.getPixel(yVal) + yDepth;
      Pb = (previousY ? yAxis.getPixel(previousY) : yBasePos) + yDepth;
      if (xAxis.config.isVertical) {
        config._Px = Py;
        config._Py = Px;
        config._Pby = Px;
        config._Pbx = Pb;
      } else {
        config._Px = Px;
        config._Py = Py;
        config._Pby = Pb;
        config._Pbx = Px;
      }
    }
  }

  getDataLimits () {
    var dataSet = this,
      dataStore = dataSet.components.data,
      conf = dataSet.config,
      i,
      config,
      len = dataStore.length, // eslint-disable-line good-practices/no-single-usage-variable
      setValue,
      maxValue = -Infinity,
      minValue = +Infinity;

    for (i = 0; i < len; i++) {
      if (!dataStore[i]) {
        continue;
      }
      config = dataStore[i].config;
      setValue = config.total;
      if (setValue !== UNDEF) {
        maxValue = Math.max(maxValue, setValue);
        minValue = Math.min(minValue, setValue);
      }
    }

    conf.maxValue = maxValue;
    conf.minValue = minValue;
    return {
      max: conf.maxValue,
      min: conf.minValue
    };
  }

  drawPlots (anim) {
    var dataSet = this;
    super.drawPlots(anim);
    if (dataSet.config.showConnectors) {
      dataSet.drawLine();
    } else {
      dataSet.getContainer('commonElemsGroup').hide();
    }
  }

  drawLine () {
    var dataSet = this,
      conf = dataSet.config,
      i,
      yPos,
      xPos,
      yAxis = dataSet.getFromEnv('yAxis'),
      yBase = yAxis.getAxisBase(), // eslint-disable-line good-practices/no-single-usage-variable
      yBasePos = yAxis.getPixel(yBase), // eslint-disable-line good-practices/no-single-usage-variable
      lineContainer = dataSet.getContainer('commonElemsGroup'),
      groupNetHalfWidth = dataSet.getFromEnv('columnWidth') / 2,
      zLineConf = conf.zLine,
      data = zLineConf.data,
      set,
      y,
      x,
      ln = data.length, // eslint-disable-line good-practices/no-single-usage-variable
      seriesLineWidth = zLineConf.lineWidth,
      lastXPos,
      zLineDummy = dataSet._graphics.zLine,
      zLine,
      lastYPos = null,
      linePath = [],
      lastMoveCommand = [];

    yAxis.yBasePos = yBasePos;
    lineContainer.toFront().show();

    for (i = 0; i < ln; i += 1) {
      set = data[i];
      y = set.y;
      if (y === null) {
        lastMoveCommand.length = 0;
        if (conf.connectNullData === 0) {
          lastYPos = null;
        }
      } else {
        x = pluckNumber(set.x, i);
        // Multi series related management.
        yPos = yAxis.getPixel(y);
        xPos = dataSet.getFromEnv('xAxis').getPixel(x);
        // crisp line positions
        xPos = getCrispValue(xPos, seriesLineWidth, seriesLineWidth).position;
        yPos = getCrispValue(yPos, seriesLineWidth, seriesLineWidth).position;

        if (lastYPos !== null) {
          if (lastMoveCommand.length) {
            linePath = linePath.concat(lastMoveCommand);
            lastMoveCommand.length = 0;
          }
          linePath.push(M, lastXPos, lastYPos, 'm', -groupNetHalfWidth, 0, H, xPos, 'h',
            groupNetHalfWidth, 'm', 0, yPos - lastYPos);
        } else {
          lastMoveCommand.push(M, xPos, yPos);
        }

        lastXPos = xPos;
        lastYPos = yPos;
      }
    }
    // If zLine is not present, create it
    zLine = dataSet.getFromEnv('animationManager').setAnimation({ // eslint-disable-line good-practices/no-single-usage-variable
      el: zLineDummy || 'path',
      attr: {
        path: linePath,
        'stroke-linecap': 'round',
        'stroke-opacity': 1,
        'stroke-dasharray': zLineConf.dashStyle,
        'stroke': zLineConf.color,
        'stroke-linejoin': seriesLineWidth >= MAX_MITER_LINEJOIN ? 'round' : 'miter',
        'stroke-width': seriesLineWidth
      },
      container: lineContainer,
      component: dataSet,
      label: 'path'
    });

    // If zline is not present previously, add to _graphics of dataset
    if (!zLineDummy) {
      dataSet.addGraphicalElement('zLine', zLine);
    }
  }
}
export default WaterFall2DDataset;
